import { render, staticRenderFns } from "./icon-bonus.vue?vue&type=template&id=383cb204&scoped=true"
var script = {}
import style0 from "./icon-bonus.vue?vue&type=style&index=0&id=383cb204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383cb204",
  null
  
)

export default component.exports